import * as React from "react";
import Component from "../../AbstractComponent";
import TextField from "../../Partials/Material/TextField";
import Constants from "../../../Action/Constants";
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
// import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
// import { Entity } from "Casadesk/Entity/Entity";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export class CoachDialogNewExecutor extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openTaskExecutorCoachDialog: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    type: "",
    disableButtonDuringRequest: false,
    //executor fields
    firstName: "",
    lastName: "",
    email: "",
    contactRoleId: null,
    personDisplayName: "",
    executor: null,
    firstNameError: false,
    phone1: "",
    errorFields: null,
    companyType: "existing",
    companyFromComponent: null,
    companyName: "",
    companyComponentError: false,
    companyNameError: false,
    company: null,
    contactDetailType: "department",
    changeDefaultChoiseFlag: false,
    isFinishDialogOpen: false
  };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      openTaskExecutorCoachDialog: this.props.openTaskExecutorCoachDialog || this.props.openTaskReporterCoachDialog,
      // type: this.props.type,
      contactRoleId: this.props.type === "user" ? 1 : 3,
    });
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({
      openTaskExecutorCoachDialog: nextProps.openTaskExecutorCoachDialog,
      type: nextProps.type,
      contactRoleId: this.props.type === "user" ? 1 : 3
    });
  }

  // public chooseExecutorType = (event) => {
  //   const choice: string = event.target.value;

  //   this.setState({
  //     type: choice,
  //   });
  // }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openTaskExecutorCoachDialog: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      type: "",
      contactRoleId: null,
      disableButtonDuringRequest: false,
      //person fields
      firstName: "",
      lastName: "",
      email: "",
      executor: null,
      firstNameError: false,
      phone1: "",
      errorFields: null,
      companyType: "existing",
      companyFromComponent: null,
      companyName: "",
      companyComponentError: false,
      companyNameError: false,
      company: null,
      contactDetailType: "department",
      changeDefaultChoiseFlag: false,
      isFinishDialogOpen: false
    });
  }

  public onCloseCoach = () => {
    this.props.onCloseCoach.call(this);
    this.clearBackEndErrors();

    setTimeout(() => { this.clearState() }, 100);
  }
  public startStep0 = () => this.props.firstStep()

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if (activeStep === steps.length - 1) { // it is last step
      if (this.state.errorFields?.length > 0) {
        this.setState({
          isFinishDialogOpen: true
        });
      } else {
        if (typeof this.props.setExecutor !== undefined && this.state.executor) {
          this.onCloseCoach();
          this.props.setExecutor.call(this, this.state.executor);
        } else {
          this.onCloseCoach();
        }
      }

    } else {
      const { activeStep } = this.state;

      if (this.props.firstStep) {
        if (activeStep === 0) {
          this.setState({
            activeStep: activeStep + 1,
          });
        }

        switch (activeStep) {
          case 0:
            return this.startStep0();
          case 1:
            return this.startStep1();
          case 2:
            return this.startStep2();
          case 3:
            return this.startStep3();
          case 4:
            return this.plusOneStep();
  
        }
      } else {
        switch (activeStep) {
          case 0:
            return this.startStep1();
          case 1:
            return this.startStep2();
          case 2:
            return this.startStep3();
          case 3:
            return this.plusOneStep();

        }
      }

    }
  };

  public handleBack = () => {
    const { activeStep } = this.state;

    if (activeStep === 0) {
      if (typeof this.props.openFirstStep !== "undefined") {
        this.clearFieldsError();
        this.clearBackEndErrors();
        this.clearState();
        return this.props.openFirstStep.call(this);
      }
    } else {
      this.clearFieldsError();
      return this.setState({
        activeStep: activeStep - 1,
      });
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    let steps;
    this.props.firstStep
    if (this.state.type === "user") {
      steps = [this.trans("coach/executor-scenario/user-step/second-title"), this.trans("coach/executor-scenario/user-step/third-title"), this.trans("coach/executor-scenario/user-step/fourth-title")];
    } else if (this.state.type === "person") {
      steps = [this.trans("coach/executor-scenario/person-step/second-title"), this.trans("coach/executor-scenario/person-step/third-title"), this.trans("coach/executor-scenario/person-step/fourth-title"), this.trans("coach/executor-scenario/person-step/fifth-title")];
    }
    else if (this.state.type === "company") {
      steps = [this.trans("coach/executor-scenario/company-step/second-title"), this.trans("coach/executor-scenario/company-step/third-title"), this.trans("coach/executor-scenario/company-step/fourth-title"), this.trans("coach/executor-scenario/company-step/fifth-title")];
    }
    else {
      steps = [this.trans("coach/executor-scenario/department-step/second-title"), this.trans("coach/executor-scenario/department-step/third-title"), this.trans("coach/executor-scenario/department-step/fourth-title")];
    }
    if (this.props.firstStep) {
      steps.unshift(this.trans("button-add-executor"))
    }

    return steps;
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    if (this.props.firstStep) {
      switch (step) {
        case 0:
          return this.stepContent(step, "");
        case 1:
          return this.stepContent(step, "");
        case 2:
          return this.stepContent(step, "");
        case 3:
          return this.stepContent(step, "");
        case 4:
          return this.stepContent(step, "");
        default:
          return this.trans("unknown-step");
      }
    } else {
      switch (step) {
        case 0:
          return this.stepContent(step, "");
        case 1:
          return this.stepContent(step, "");
        case 2:
          return this.stepContent(step, "");
        case 3:
          return this.stepContent(step, "");
        default:
          return this.trans("unknown-step");
      }
    }

  }

  // Content details for diffenrent steps.
  public stepContent = (step, subtitle) => {
    return (
      <div>
        <div>
          {this.sectionTitle(subtitle)}
        </div>
        
        {(step === 0 && !!this.props.firstStep) && this.props.firstStep()}
        {(step === 1 && !!this.props.firstStep) && this.firstStepDetails() }
        {(step === 2 && !!this.props.firstStep) && this.secondStepDetails()}
        {(step === 3 && !!this.props.firstStep) && this.thirdStepDetails() }
        {(step === 4 && !!this.props.firstStep) && this.fourthStepDetails()}

        {(step === 0 && !this.props.firstStep) && this.firstStepDetails()}
        {(step === 1 && !this.props.firstStep) && this.secondStepDetails()}
        {(step === 2 && !this.props.firstStep) && this.thirdStepDetails()}
        {(step === 3 && !this.props.firstStep) && this.fourthStepDetails()}
        
      </div>
    )
  }


  // Steppers components content
  public firstStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepFirst();
      case "person":
        return this.personStepFirst();
      case "department":
        return this.departmentStepFirst();
      case "user":
        return this.userStepFirst();
    }
  }

  public secondStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepSecond();
      case "person":
        return this.personStepSecond();
      case "department":
        return this.departmentStepSecond();
      case "user":
        return this.userStepSecond();
    }
  }


  public thirdStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepThird();
      case "person":
        return this.personStepThird();
      case "department":
        return this.departmentStepThird();
      case "user":
        return this.userStepThird();
    }
  }

  public fourthStepDetails = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStepFourth();
      case "person":
        return this.personStepFourth();
      case "department":
      // return this.departmentStepFourth();
    }
  }

  //Components
  public personStepFirst = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-next">{this.trans("coach/executor-scenario/person-step/second-info1")}</div>
        <div>
          <TextField
            autoComplete="off"
            // id="firstName"
            // name="firstName"
            className="form-element full-size"
            type="text"
            label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
            value={this.state.firstName}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
            autoFocus={true}
            variant="standard"
            error={this.state.firstNameError || this.getErrorFor("contacts.firstName") || this.getErrorFor("firstName")}
          />
          {!!this.getErrorFor("contacts.firstName") || !!this.getErrorFor("firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName") ? this.getErrorFor("contacts.firstName") : this.getErrorFor("firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

          <TextField
            autoComplete="off"
            // id="lastName"
            // name="lastName"
            className="form-element full-size"
            type="text"
            label={this.trans("coach/executor-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
            value={this.state.lastName}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
            variant="standard"
            error={!!this.getErrorFor("lastName")}
          />
          {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}
          {

          }
          <TextField
            autoComplete="off"
            className="form-element full-size"
            label={`${this.trans("coach/executor-scenario/person-step/second-field/email-label")} ${this.state.type === "person" ? this.trans("field/optional") : ""}`}
            value={this.state.email}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
            variant="standard"
            error={!!this.getErrorFor("email") || !!this.getErrorFor("contacts.email")}
          />
          {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

          <div>
            <TextField
              autoComplete="off"
              // id="phone1"
              //name="phone1"
              className="form-element full-size"
              type="text"
              label={this.trans("phone") + this.trans("field/optional")}
              value={this.state.phone1}
              onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
              variant="standard"
              error={!!this.getErrorFor("phone1")}
            />
            {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
          </div>
        </div>
      </div>
    );
  }

  public personStepSecond = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/person-step/third-info1")}
        </div>
        <div>
          <RadioGroup
            name="contactDetailChoice"
            className="filters-container"
            value={this.state.companyType}
            onChange={this.chooseCompanyType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="existing"
              label={this.trans("coach/executor-radiobutton/existingcompany")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="newcompany"
              label={this.trans("coach/executor-radiobutton/newcompany")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="nocompany"
              label={this.trans("coach/executor-radiobutton/nocompany")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>
        <div>
          {this.state.companyType === "existing" &&
            <div>
              <CompanyLookup
                {...this.props}
                floatingLabelText={this.trans("dropdown-searchforcompany-label")}
                searchText={this.state.companyFromComponent && this.state.companyFromComponent.displayName}
                autoSelectId={this.state.companyFromComponent && this.state.companyFromComponent.id}
                isInlineBlock={true}
                width="100%"
                height="60px"
                containerWidth="100%"
                onClear={this.clearCompany}
                onSelect={this.selectCompany}
                saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "personCreate")}
                forceUpdatePage={true}
                disableEntityCreation={true}
                styleInModal={"styleInModal"}
                hideClickThroughLink={true}
                error={this.state.companyComponentError && this.trans("this-field-is-required") || this.getErrorFor("name")}
              />
            </div>
          }
          {this.state.companyType === "newcompany" &&
            <div>
              <TextField
                autoComplete="off"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/poaowner-scenario/company-step/first-field/companyname-label")}
                value={this.state.companyName}
                onChange={this.setCompanyName}
                autoFocus={true}
                variant="standard"
                error={this.state.companyNameError || this.getErrorFor("name")}
              />
              {!!this.getErrorFor("name") ? <div className="component-error-text">{this.getErrorFor("name")}</div> : this.state.companyNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
            </div>
          }
        </div>
      </div>
    )
  }

  public personStepThird = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/person-step/fourth-info1")}
        </div>
        <div>
          <ul>
            <li>{`${this.trans("coach/executor-scenario/person-step/fourth-label/person")} ${this.state.firstName}${this.state.lastName && ` ${this.state.lastName}`}${this.state.email && `, ${this.state.email}`}${this.state.phone1 && `, ${this.state.phone1}`}`}</li>
            {this.state.companyType !== "nocompany" && <li>{`${this.trans("coach/executor-scenario/person-step/fourth-label/companyname")} ${this.state.companyFromComponent ? this.state.companyFromComponent.displayName : this.state.companyName}`}</li>}
          </ul>
        </div>
      </div>
    )
  }

  public personStepFourth = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.executor ?
          <div>
            <div className="info-text">
              {this.trans("coach/executor-scenario/person-step/fifth-info1")}
            </div>
            <div className="success-created-entity-or-error">
              {this.state.executor.displayName}
            </div>
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map(item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", { field: transField })}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  public companyStepFirst = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/company-step/second-info1")}
        </div>
        <div>
          <TextField
            autoComplete="off"
            className="form-element full-size"
            type="text"
            label={this.trans("coach/poaowner-scenario/company-step/first-field/companyname-label")}
            value={this.state.companyName}
            onChange={this.setCompanyName}
            autoFocus={true}
            variant="standard"
            error={this.state.companyNameError || this.getErrorFor("name")}
          />
          {!!this.getErrorFor("name") ? <div className="component-error-text">{this.getErrorFor("name")}</div> : this.state.companyNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
        </div>
      </div>
    );
  }

  public companyStepSecond = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/company-step/third-info1")}
        </div>
        <div>
          <RadioGroup
            name="contactDetailChoice"
            className="filters-container"
            value={this.state.contactDetailType}
            onChange={this.chooseContactDetailType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/poaowner-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/poaowner-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>
        <div>
          {this.state.contactDetailType === "person" &&
            <div>
              <TextField
                autoComplete="off"
                // id="firstName"
                // name="firstName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
                value={this.state.firstName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                autoFocus={true}
                variant="standard"
                error={this.state.firstNameError || this.getErrorFor("contacts.firstName")}
              />
              {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

              <TextField
                autoComplete="off"
                // id="lastName"
                // name="lastName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/propertyowner-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
                value={this.state.lastName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
                variant="standard"
                error={!!this.getErrorFor("lastName")}
              />
              {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}

              <TextField
                autoComplete="off"
                className="form-element full-size"
                label={this.trans("label-email") + this.trans("field/optional")}
                value={this.state.email}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                variant="standard"
                error={!!this.getErrorFor("email")}
              />
              {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

              <div>
                <TextField
                  autoComplete="off"
                  // id="phone1"
                  //name="phone1"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("phone") + this.trans("field/optional")}
                  value={this.state.phone1}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                  variant="standard"
                  error={!!this.getErrorFor("phone1")}
                />
                {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
              </div>
            </div>
          }
          {this.state.contactDetailType === "department" &&
            <div>
              <TextField
                autoComplete="off"
                // id="firstName"
                // name="firstName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/poaowner-scenario/company-step/second-field/department-label")}
                value={this.state.firstName}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
                autoFocus={true}
                variant="standard"
                error={this.state.firstNameError || this.getErrorFor("contacts.firstName")}
              />
              {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

              <TextField
                autoComplete="off"
                className="form-element full-size"
                label={this.trans("label-email") + this.trans("field/optional")}
                value={this.state.email}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
                variant="standard"
                error={!!this.getErrorFor("email")}
              />
              {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>
              }
              <div>
                <TextField
                  autoComplete="off"
                  // id="phone1"
                  //name="phone1"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("phone") + this.trans("field/optional")}
                  value={this.state.phone1}
                  onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
                  variant="standard"
                  error={!!this.getErrorFor("phone1")}
                />
                {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
              </div>
            </div>
          }
        </div>
      </div>
    )
  }

  public companyStepThird = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/company-step/fourth-info1")}
        </div>
        <div>
          <ul>
            <li>{`${this.trans("coach/executor-scenario/company-step/fourth-label/newcompany")} ${this.state.companyName || ""}`}</li>
            <li>{`${this.state.contactDetailType === "department" ? this.trans("coach/executor-scenario/company-step/fourth-label/department") : this.trans("coach/executor-scenario/company-step/fourth-label/newperson")} ${this.state.firstName}${this.state.lastName && ` ${this.state.lastName}`}${this.state.email && `, ${this.state.email}`}${this.state.phone1 && `, ${this.state.phone1}`}`}</li>
          </ul>
        </div>
      </div>
    )
  }

  public companyStepFourth = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.executor ?
          <div>
            <div className="info-text">
              {this.trans("coach/executor-scenario/company-step/fifth-info1")}
            </div>
            <div className="success-created-entity-or-error">
              {this.state.executor.displayName}
            </div>
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map(item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", { field: transField })}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  public departmentStepFirst = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/department-step/second-info1")}
        </div>
        <CompanyLookup
          {...this.props}
          floatingLabelText={this.trans("dropdown-searchforcompany-label")}
          searchText={this.state.companyFromComponent && this.state.companyFromComponent.displayName}
          autoSelectId={this.state.companyFromComponent && this.state.companyFromComponent.id}
          isInlineBlock={true}
          width="100%"
          height="60px"
          containerWidth="100%"
          onClear={this.clearCompany}
          onSelect={this.selectCompany}
          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "personCreate")}
          forceUpdatePage={true}
          disableEntityCreation={true}
          styleInModal={"styleInModal"}
          hideClickThroughLink={true}
          error={this.state.companyComponentError && this.trans("this-field-is-required") || this.getErrorFor("name")}
        />
        <TextField
          autoComplete="off"
          // id="firstName"
          // name="firstName"
          className="form-element full-size"
          type="text"
          label={this.trans("coach/poaowner-scenario/company-step/second-field/department-label")}
          value={this.state.firstName}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
          variant="standard"
          error={this.state.firstNameError || this.getErrorFor("contacts.firstName")}
        />
        {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

        <TextField
          autoComplete="off"
          className="form-element full-size"
          label={this.trans("label-email") + this.trans("field/optional")}
          value={this.state.email}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
          variant="standard"
          error={!!this.getErrorFor("email") || !!this.getErrorFor("contacts.email")}
        />
        {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
        <div>
          <TextField
            autoComplete="off"
            // id="phone1"
            //name="phone1"
            className="form-element full-size"
            type="text"
            label={this.trans("phone") + this.trans("field/optional")}
            value={this.state.phone1}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
            variant="standard"
            error={!!this.getErrorFor("phone1")}
          />
          {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
        </div>
      </div>
    );
  }

  public departmentStepSecond = () => {
    return (
      <div className="coach-content-wrapper">
        <div className="info-text">
          {this.trans("coach/executor-scenario/company-step/fourth-info1")}
        </div>
        <div>
          <ul>
            <li>{`${this.state.contactDetailType === "department" ? this.trans("coach/executor-scenario/company-step/fourth-label/department") : this.trans("coach/executor-scenario/company-step/fourth-label/newperson")} ${this.state.firstName}${this.state.lastName && ` ${this.state.lastName}`}${this.state.email && `, ${this.state.email}`}${this.state.phone1 && `, ${this.state.phone1}`}`}</li>
            <li>{`${this.trans("coach/executor-scenario/company-step/fourth-label/newcompany")} ${this.state.companyFromComponent && this.state.companyFromComponent.displayName}`}</li>
          </ul>
        </div>
      </div>
    );
  }

  public departmentStepThird = () => {
    return (
      <div className="coach-content-wrapper">
        {this.state.executor ?
          <div>
            <div className="info-text">
              {this.trans("coach/executor-scenario/company-step/fifth-info1")}
            </div>
            <div className="success-created-entity-or-error">
              {this.state.executor.displayName}
            </div>
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map(item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", { field: transField })}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  public userStepFirst = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/executor-scenario/user-step/second-info1")}
        </div>
        <TextField
          autoComplete="off"
          // id="firstName"
          // name="firstName"
          className="form-element full-size"
          type="text"
          label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
          value={this.state.firstName}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "firstName")}
          autoFocus={true}
          variant="standard"
          error={this.state.firstNameError || this.getErrorFor("contacts.firstName") || this.getErrorFor("firstName")}
        />
        {!!this.getErrorFor("contacts.firstName") || !!this.getErrorFor("firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName") ? this.getErrorFor("contacts.firstName") : this.getErrorFor("firstName")}</div> : this.state.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}
        <TextField
          autoComplete="off"
          // id="lastName"
          // name="lastName"
          className="form-element full-size"
          type="text"
          label={this.trans("coach/propertyowner-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
          value={this.state.lastName}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "lastName")}
          variant="standard"
          error={!!this.getErrorFor("lastName")}
        />
        {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}
        <TextField
          autoComplete="off"
          className="form-element full-size"
          label={this.trans("label-email")}
          value={this.state.email}
          onChange={this.sync.bind(this, this.syncronizers.EVENT, "email")}
          variant="standard"
          error={!!this.getErrorFor("email")}
        />
        {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

        <div>
          <TextField
            autoComplete="off"
            // id="phone1"
            //name="phone1"
            className="form-element full-size"
            type="text"
            label={this.trans("phone") + this.trans("field/optional")}
            value={this.state.phone1}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "phone1")}
            variant="standard"
            error={!!this.getErrorFor("phone1")}
          />
          {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
        </div>
      </div>
    );
  }

  public userStepSecond = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/executor-scenario/user-step/fourth-info1")}
        </div>
        <div>
          <ul>
            <li>{`${this.trans("coach/executor-scenario/user-step/fourth-label/newuser")} ${this.state.firstName}${this.state.lastName && ` ${this.state.lastName}`}`}</li>
            {this.state.email && <li>{this.state.email}</li>}
            {this.state.phone1 && <li>{this.state.phone1}</li>}
          </ul>
        </div>
      </div>
    );
  }

  public userStepThird = () => {
    return (
      <div>
        {this.state.executor ?
          <div>
            <div className="info-text">
              {this.trans("coach/executor-scenario/company-step/fifth-info1")}
            </div>
            <div className="success-created-entity-or-error info-text">
              {this.state.executor.displayName}
            </div>
            <div className="info-text hint-styles-dialog">
              {this.trans("coach/executor-scenario/user-step/fifth-info2")}
            </div>
          </div>
          :
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map(item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", { field: transField })}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }


  // Reusebale title components

  public sectionTitle = (text) => {
    return (
      <div className="section-info-text">
        <div>{text}</div>
      </div>
    );
  }

  public sectionFieldTitle = (text) => {
    return (
      <div className="section-info-text">
        <h4>{text}</h4>
      </div>
    );
  }

  //Funcionality for steps
  //FIRST STEP LOGIC
  public startStep1 = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStepFirst();
      case "person":
        return this.personStartStepFirst();
      case "department":
        return this.departmentStartStepFirst();
      case "user":
        return this.userStartStepFirst();
    }
  }

  //SECOND STEP LOGIC
  public startStep2 = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStepSecond();
      case "person":
        return this.personStartStepSecond();
      case "department":
        return this.departmentStartStepSecond();
      case "user":
        return this.userStartStepSecond();
    }
  }

  //THIRD STEP LOGIC
  public startStep3 = () => {
    switch (this.state.type) {
      case "company":
        return this.companyStartStepThird();
      case "person":
        return this.personStartStepThird();
    }
  }


  //Methods for step logic
  public getPayloadForPerson = (): any => {
    let pageTemplate = "person";
    if (this.state.type !== "company" && (this.state.companyType === "nocompany" || this.state.companyType === "existing")) {
      return {
        person: {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          profession: "",
          email: this.state.email,
          phone1: this.state.phone1,
          phone2: "",
          contactRoleId: 3,
          mainBankAccountId: "",
          companyId: (this.state.companyType === "existing" || this.state.type === "department") && this.state.companyFromComponent ? this.state.companyFromComponent.id : null,
          address: {
            formattedAddress: ""
          },
          dateOfBirth: null,
          placeOfBirth: {
            formattedAddress: ""
          },
          identityNumber: "",
          identityType: 255,
          amazonFolderName: "",
          note: "",
          pageTemplate: pageTemplate,
          genderTypeId: 3,
          languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,
        }
      };
    } else {
      return {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        profession: "",
        email: this.state.email,
        phone1: this.state.phone1,
        phone2: "",
        contactRoleId: null,
        mainBankAccountId: "",
        companyId: null,
        address: {
          formattedAddress: ""
        },
        dateOfBirth: null,
        placeOfBirth: {
          formattedAddress: ""
        },
        identityNumber: "",
        identityType: 255,
        amazonFolderName: "",
        note: "",
        pageTemplate: pageTemplate,
        genderTypeId: 3,
        languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,
      };
    }
  }

  public createPerson = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: this.getPayloadForPerson(),
        onSuccess: person => {
          this.setState({
            executor: person,
            disableButtonDuringRequest: false,
            errorFields: []
          })
          this.plusOneStep()
        },
        onError: error => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields
          });
          this.plusOneStep()
        }
      });
    });
  }

  public personStartStepFirst = () => {
    if (this.state.firstName === "") {
      this.setState({
        firstNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public personStartStepSecond = () => {
    if ((this.state.companyName === "" && !this.state.companyFromComponent) && this.state.companyType !== "nocompany") {
      if (this.state.companyType === "newcompany") {
        this.setState({
          companyNameError: true
        })
      }
      if (this.state.companyType === "existing")
        this.setState({
          companyComponentError: true
        })
    } else {
      this.plusOneStep();
    }
  }

  public personStartStepThird = () => {
    const pageTemplate = "company";
    if (this.state.companyType === "nocompany" || this.state.companyType === "existing") {
      this.createPerson();
    } else {
      this.saving(() => {
        this.setState({
          disableButtonDuringRequest: true
        })
        this.props.dispatch({
          type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
          payload: {
            company: {
              name: this.state.companyName !== "" && this.state.companyType === "newcompany" ? this.state.companyName
                :
                this.state.companyFromComponent && this.state.companyFromComponent.displayName,
              email: "",
              phone: "",
              mainBankAccountId: "",
              address: null,
              amazonFolderName: "",
              note: "",
              pageTemplate: pageTemplate,
              contacts:
              {
                ...this.getPayloadForPerson()
              }
            }
          },
          onSuccess: (company) => {
            this.setState({
              company: company,
              // executor: company.persons[0] ? company.persons[0] : company.personIds[0] && { displayName: `${this.state.firstName}  ${this.state.lastName}`, id: company.personIds[0] },
              executor: company,
              disableButtonDuringRequest: false,
              errorFields: [],
            })
            this.plusOneStep()
          },
          onError: (error) => {
            this.setState({
              disableButtonDuringRequest: false,
              errorFields: error.fields
            })
            this.plusOneStep()
          }
        });
      });
    }
  }

  public companyStartStepFirst = () => {
    if (this.state.companyName === "") {
      this.setState({
        companyNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public companyStartStepSecond = () => {
    if (this.state.firstName === "") {
      this.setState({
        firstNameError: true
      })
    } else {
      this.setState({
        startCoachFlag: true
      })
      this.plusOneStep();
    }
  }

  public companyStartStepThird = () => {
    const pageTemplate = "company";
    this.saving(() => {
      this.setState({
        disableButtonDuringRequest: true
      })
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_COMPANY_CREATE_START,
        payload: {
          company: {
            name: this.state.companyName,
            email: "",
            phone: "",
            mainBankAccountId: "",
            address: null,
            amazonFolderName: "",
            note: "",
            pageTemplate: pageTemplate,
            contacts:
            {
              ...this.getPayloadForPerson()

            }
          }
        },
        onSuccess: (company) => {
          this.setState({
            company: company,
            // executor: company.persons[0] ? company.persons[0] : company.personIds[0] && { displayName: `${this.state.firstName}  ${this.state.lastName}`, id: company.personIds[0] },
            executor: company,
            disableButtonDuringRequest: false,
            errorFields: []
          })

          this.plusOneStep()
        },
        onError: (error) => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields
          })
          this.plusOneStep()
        }
      });
    });
  }

  public departmentStartStepFirst = () => {
    if (!this.state.companyFromComponent) {
      this.setState({
        companyComponentError: true
      })
    } else if (this.state.firstName === "") {
      this.setState({
        firstNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public departmentStartStepSecond = () => {
    this.createPerson();
  }

  public userStartStepFirst = () => {
    if (this.state.firstName === "") {
      this.setState({
        firstNameError: true
      })
    } else {
      this.plusOneStep();
    }
  }

  public userStartStepSecond = () => {
    this.createPerson();
  }


  //Methods
  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false,
      companyComponentError: false
    })
  }

  public chooseCompanyType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      companyType: choice,
      companyFromComponent: null,
      companyName: ""
    }, () => {
      this.clearFieldsError();
      this.clearBackEndErrors();
    });
  }

  public selectCompany = (company: CompanyInterface): void => {
    this.setState({
      companyFromComponent: company
    });
  }

  public clearCompany = (): any => {
    this.setState({
      companyFromComponent: null
    });
  }

  public setCompanyName = (event) => {
    this.setState({
      companyName: event.target.value
    })
  }

  public chooseContactDetailType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      contactDetailType: choice,
      firstName: "",
      lastName: "",
      email: "",
      phone1: "",
      changeDefaultChoiseFlag: true
    }, () => {
      this.clearFieldsError();
      this.clearBackEndErrors();
    });
  }

  // public renderContent = () => {
  //   const steps = this.getSteps();
  //   const { activeStep } = this.state;
  //   let errorFieldsLength;

  //   if (this.state.errorFields) {
  //     errorFieldsLength = this.state.errorFields.length
  //   }

  //   return (
  //     <div className="stepper-wrapper">
  //       <div className="stepper-container">
  //         {activeStep !== steps.length &&
  //           <Stepper activeStep={activeStep}>
  //             {steps.map((label) => {
  //               const props = {};
  //               const labelProps = {};
  //               return (
  //                 <Step key={label} {...props}>
  //                   <StepLabel {...labelProps}>{label}</StepLabel>
  //                 </Step>
  //               );
  //             })}
  //           </Stepper>
  //         }
  //         <div>
  //           <div className="step-content-wrapper">
  //             {this.getStepContent(activeStep)}
  //           </div>
  //         </div>
  //       </div>
  //       {activeStep !== steps.length &&
  //         <div className={`step-content-button-wrapper button-container ${activeStep === steps.length - 1 ? "without-cancel" : ""}`} >
  //           {activeStep !== steps.length - 1 &&
  //             <Button
  //               variant="contained"
  //               color="primary"
  //               onClick={this.onCloseCoach}
  //               className="cancel-button"
  //             >
  //               {this.trans("dialog-button/cancel")}
  //             </Button>
  //           }

  //           <div>
  //             {errorFieldsLength !== 0 &&
  //               <Button
  //                 color="primary"
  //                 variant="outlined"
  //                 onClick={this.handleBack}
  //                 disabled={this.state.disableButtonDuringRequest}
  //                 className="back-button"
  //               >
  //                 {this.trans("dialog-button/back")}
  //               </Button>
  //             }

  //             <Button
  //               variant="contained"
  //               color="primary"
  //               onClick={this.handleNext}
  //               disabled={this.state.disableButtonDuringRequest}
  //             >
  //               {activeStep === steps.length - 1 ? this.trans("dialog-button/close") : this.trans("coach/propertyowner-button/next")}
  //             </Button>
  //           </div>
  //         </div>
  //       }
  //     </div>
  //   )
  // }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openTaskExecutorCoachDialog}
          onCloseCoach={this.onCloseCoach}
          onNext={this.handleNext}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({ activeStep, isDisabled: false })
          }}
          showBackButton={this.state.activeStep !== steps.length - 1}
        // disabledNext={
        //   (this.state.activeStep === 0 && !this.state.company) ||
        //   (this.state.activeStep === 1 && !this.state.property) ||
        //   (this.state.activeStep === 2 && !this.state.unit) ||
        //   (this.state.activeStep === 4 && !this.state.fixedFee)
        // }
        />
        {/* <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isFinishDialogOpen}
          title={this.trans("title-attention") + "!"}
          content={this.trans("coach-loseinformation/info")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isFinishDialogOpen: false }, this.onCloseCoach)}
          onDiscard={() => this.setState({ isFinishDialogOpen: false, considerPaidProcess: false }) }
        /> */}
        {/* <PageTransition isSaving={this.state.isSaving} /> */}
      </div>
    );
  }
  // public render() {
  //   return (
  //     <div>
  //       <Dialog
  //         className={`dialog dialog-window dialog-assistant coach-executor has-button-padding ${this.props.innerDialogClasses}`}
  //         open={this.state.openTaskExecutorCoachDialog}
  //         onClose={this.onCloseCoach}
  //         disableBackdropClick={true}
  //       >
  //         <DialogContent>
  //           {this.renderContent()}
  //         </DialogContent>
  //       </Dialog>

  //       <PromptDialog
  //         {...this.props}
  //         openLeavePrompt={this.state.isFinishDialogOpen}
  //         title={this.trans("title-attention") + "!"}
  //         content={this.trans("coach-loseinformation/info")}
  //         positiveButtonLabel={this.trans("dialog-button/continue")}
  //         negativeButtonLabel={this.trans("dialog-button/cancel")}
  //         onSave={() => this.setState({ isFinishDialogOpen: false }, this.onCloseCoach)}
  //         onDiscard={() => this.setState({ isFinishDialogOpen: false, considerPaidProcess: false }) }
  //       />
  //     </div>
  //   );
  // }
}
